import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams, Link } from "react-router-dom";
import Loader from "../../../components/Layout/Loader";
import styles from "../../../styles/styles";

const ProductsPage = () => {
  const [searchParams] = useSearchParams();
  const categoryData = searchParams.get("category");
  const { allProducts, isLoading } = useSelector((state) => state.products);
  const [data, setData] = useState([]);
  const [shopName, setShopName] = useState("");
  const [flip, setFlip] = useState(true);


  useEffect(() => {
    // Extract shop name from URL
    const url = window.location.href;

    try {
      const urlObject = new URL(url);
      const formattedUrl = urlObject.hostname.replace("www.", ""); // Remove 'www.' if present
      let extractedShopName = "";

      if (formattedUrl === "localhost") {
        extractedShopName = "redfarma"; // Provide a default shop name for localhost
      } else {
        extractedShopName = formattedUrl.split(".")[0]; // Extract subdomain
      }

      setShopName(extractedShopName);
    } catch (error) {
      setShopName("redfarma"); // Fallback shop name if parsing fails
    }
  }, []);


  return (
    <>
      {isLoading ? (
        <Loader />
      ):
      (
        <div
          className={`relative min-h-[70vh] 800px:min-h-[80vh] w-full bg-no-repeat ${styles.noramlFlex}`}
          style={{
            backgroundImage: "url(/home-page.jpg)",
          }}
        >
          <div className={`${styles.section} w-[90%] 800px:w-[60%]`}>
            <h1
              className={`text-[35px] leading-[1.2] 800px:text-[60px] text-[#3d3a3a] font-[600] capitalize transform transition-transform duration-500`}
              style={{ transform: flip ? "rotateY(0)" : "rotateY(180deg)" }}
            >
              Best Collection for <br /> home Decoration
            </h1>
            <p className="pt-5 text-[16px] font-[Poppins] font-[400] text-[#000000ba]">
              Get your products from your nearby shop! <br /> Talk to your favourite seller and ensure COD (Cash on Delivery){" "}
              <br /> Get everything in one place.
            </p>
            <Link to="/" className="inline-block">
              <div className={`${styles.button} mt-5`}>
                <span className="text-[#fff] font-[Poppins] text-[18px]">Shop Now</span>
              </div>
            </Link>
          </div>
        </div>

      )}
    </>
  );
};

export default ProductsPage;


    